export default "__VITE_ASSET__DPKJNKc9__"